const subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    const promises = subscribers[eventName].map((callback) => {
      try {
        return callback(data);
      } catch (e) {
        // eslint-disable-next-line no-console -- surface subscriber callback errors for debugging
        console.error(e);
        return undefined;
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve();
  }
}
